// Admin Notification Service
// Tracks changes in admin stats and plays notification sounds

import { playNotificationSound } from './notificationService';

const ADMIN_STATS_KEY = 'brownstone_admin_last_stats';

// Get last stored admin stats
export const getLastAdminStats = () => {
  try {
    const stored = localStorage.getItem(ADMIN_STATS_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

// Save current admin stats
export const saveAdminStats = (stats) => {
  try {
    localStorage.setItem(ADMIN_STATS_KEY, JSON.stringify({
      total_subscribers: stats.total_subscribers,
      app_installs: stats.app_installs,
      total_users: stats.total_users,
      timestamp: Date.now()
    }));
  } catch (error) {
    console.warn('Could not save admin stats:', error);
  }
};

// Check for changes and return what's new
export const checkAdminStatsChanges = (currentStats) => {
  const lastStats = getLastAdminStats();
  const changes = [];
  
  // First time - just save and return empty
  if (!lastStats) {
    saveAdminStats(currentStats);
    return { changes: [], hasChanges: false };
  }
  
  // Check for new subscribers
  if (currentStats.total_subscribers > lastStats.total_subscribers) {
    const newCount = currentStats.total_subscribers - lastStats.total_subscribers;
    changes.push({
      type: 'subscriber',
      message: `${newCount} new subscriber${newCount > 1 ? 's' : ''}!`,
      icon: '📧',
      count: newCount
    });
  }
  
  // Check for new app installs
  if (currentStats.app_installs > lastStats.app_installs) {
    const newCount = currentStats.app_installs - lastStats.app_installs;
    changes.push({
      type: 'install',
      message: `${newCount} new app install${newCount > 1 ? 's' : ''}!`,
      icon: '📱',
      count: newCount
    });
  }
  
  // Check for new users
  if (currentStats.total_users > lastStats.total_users) {
    const newCount = currentStats.total_users - lastStats.total_users;
    changes.push({
      type: 'user',
      message: `${newCount} new user${newCount > 1 ? 's' : ''} joined!`,
      icon: '👤',
      count: newCount
    });
  }
  
  // Save current stats
  saveAdminStats(currentStats);
  
  return {
    changes,
    hasChanges: changes.length > 0
  };
};

// Play notification and show toast for admin updates
export const notifyAdminChanges = (changes, showToast) => {
  if (changes.length === 0) return;
  
  // Play sound
  playNotificationSound();
  
  // Show toast for each change
  changes.forEach((change, index) => {
    setTimeout(() => {
      if (showToast) {
        showToast(`${change.icon} ${change.message}`);
      }
    }, index * 500); // Stagger toasts
  });
};
